import SessionRepository from 'domain/repository/session/SessionRepository'
import TokenRefreshService from './TokenRefreshService'

// Единственный экземпляр на всё приложение — разделяется между interceptor и context.
const tokenRefreshService = new TokenRefreshService(new SessionRepository())
export default tokenRefreshService
